import React from 'react';
import { Section } from '../ui/Section';
import { ListChecks, BookOpen, ChefHat } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: ListChecks,
    step: '01',
    title: 'Elegí tu kit',
    desc: 'Según tu estilo, dieta o presupuesto. Tenés 6 opciones para elegir.'
  }, {
    icon: BookOpen,
    step: '02',
    title: 'Elegí tus recetas',
    desc: 'Cada kit tiene 30 recetas. Marcá las que más te gusten para tu semana.'
  }, {
    icon: ChefHat,
    step: '03',
    title: 'Cociná, porcioná, congelá',
    desc: 'Dedicá una tarde a cocinar por tandas. Durante la semana, solo recalentás.'
  }];
  return <Section data-id="element-117">
      <div className="text-center mb-6 md:mb-10" data-id="element-118">
        <span className="text-brand-caramel font-semibold text-xs md:text-sm uppercase tracking-wider" style={{
        fontSize: "16px"
      }} data-id="element-119">
          ¿Cómo funciona?
        </span>
        <h2 className="text-2xl md:text-4xl font-bold text-brand-slate-900 mt-2 mb-3 md:mb-4" data-id="element-120">
          3 pasos simples
        </h2>
        <p className="text-sm md:text-base text-brand-slate-600 max-w-xl mx-auto" data-id="element-121">
          Un sistema probado para que cocines menos y comas mejor.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6" data-id="element-122">
        {steps.map((step, i) => <div key={i} className="relative" data-id="element-123">
            <div className="bg-white p-4 md:p-6 rounded-2xl border border-brand-slate-200 h-full" data-id="element-124">
              <span className="text-3xl md:text-5xl font-bold text-brand-frost" data-id="element-125">
                {step.step}
              </span>
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-brand-ice flex items-center justify-center my-3 md:my-4" data-id="element-126">
                <step.icon className="w-4 h-4 md:w-5 md:h-5 text-brand-sky" data-id="element-127" />
              </div>
              <h3 className="text-sm md:text-lg font-semibold text-brand-slate-900 mb-1 md:mb-2" data-id="element-128">
                {step.title}
              </h3>
              <p className="text-brand-slate-600 text-xs md:text-sm leading-relaxed" data-id="element-129">
                {step.desc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}